import React from 'react';

interface SelectInputOption {
    value: string;
    label: string;
}

interface SelectInputProps {
    label?: string;
    options: SelectInputOption[];
    selectedValue: string | undefined; // Ensure this is correctly managed in the parent component
    onChange: (value: string) => void; // Callback for value change
    placeholder?: string;
    required?: boolean;
    disabled?: boolean;
    showRequiredIndicator?:boolean;
}

const SelectInput: React.FC<SelectInputProps> = ({
    label,
    options,
    selectedValue,
    onChange,
    placeholder = "Select an option",
    required = false,
    showRequiredIndicator = true,
}) => {
    return (
        <div className="mb-4">
            <label className="block text-black text-sm mb-2">
                {label} {required && showRequiredIndicator && '*'}
            </label>
            <select
                value={selectedValue ?? ""} // Ensure we use an empty string if selectedValue is undefined
                onChange={(e) => onChange(e.target.value)}
                className="w-full p-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary"
                required={required}
            >
                <option value="" disabled>{placeholder}</option>
                {options.map((option) => (
                    <option key={option.value} value={option.value}>
                        {option.label}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default SelectInput;
